import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  return <motion.a href="https://wa.me/34690752576?text=Hola%2C%20he%20visto%20tu%20web%20y%20me%20gustar%C3%ADa%20recibir%20informaci%C3%B3n%20sobre%20tus%20sesiones%20%F0%9F%99%8F" target="_blank" rel="noopener noreferrer" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1,
    type: 'spring',
    stiffness: 200,
    damping: 20
  }} className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex items-center justify-center group" aria-label="Contactar por WhatsApp" data-id="element-313">
      <MessageCircle size={28} data-id="element-314" />
      <span className="absolute right-full mr-4 bg-white text-stone-800 text-sm py-2 px-4 rounded-lg shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none" data-id="element-315">
        ¿Hablamos?
      </span>
    </motion.a>;
}